export const KIND_STAFF = "staff_expense";
export const KIND_SUPPLIER = "supplier_invoice";

/**
 * Naranja = firmado empleado (o equivalente de trámite);
 * verde = validado supervisor; rojo = pendiente de firma (estados previos a firma / borrador);
 * demás: neutro o según A3.
 */
export function getExpenseUserStatusChipProps(status, kind) {
  if (status === "signed_supervisor") {
    return { color: "success", variant: "filled" };
  }
  if (status === "signed_employee" || (status === "pending_admin" && kind === KIND_STAFF)) {
    return { color: "warning", variant: "filled" };
  }
  if (status === "extracted" || status === "draft") {
    return { color: "error", variant: "filled" };
  }
  if (status === "posted_a3") {
    return { color: "default", variant: "outlined" };
  }
  if (status === "cancelled") {
    return { color: "error", variant: "filled" };
  }
  if (status === "pending_admin" && kind === KIND_SUPPLIER) {
    return { color: "warning", variant: "filled" };
  }
  return { color: "default", variant: "outlined" };
}
